import { API } from "./axiosInstance"

/**
 * Gets all the membersFunctionalitiesMembers
 * @returns the membersFunctionalitiesMembers
 */
export const getMemberFunctionalitiesMembers = async (memberId) => {
    const membersFunctionalitiesMembers = await API.get(`/membersFunctionalitiesMembers?memberId=${memberId}`);
    return membersFunctionalitiesMembers.data;
}

/**
 * Calls the put membersFunctionalitiesMember endpoint
 * @param {*} membersFunctionalitiesMember the membersFunctionalitiesMember to update
 * @param {*} staticId the id of the membersFunctionalitiesMember to update
 * @returns the response from usermanagement-service
 */
 export const updateMemberFunctionalitiesMembers = async (membersFunctionalitiesMember, staticId) => {
    const response = await API.put(`/membersFunctionalitiesMembers/${staticId}`, membersFunctionalitiesMember);
    return response.data;
}

/**
 * Calls the POST membersFunctionalitiesMember endpoint
 * @param {*} membersFunctionalitiesMember the membersFunctionalitiesMember to create
 * @returns the response from usermanagement-service
 */
export const createMemberFunctionalitiesMembers = async (membersFunctionalitiesMember) => {
    const response = await API.post(`/membersFunctionalitiesMembers`, membersFunctionalitiesMember);
    return response.data;
}

/**
 * Accepts a requested change for a machtiging
 * @param {*} staticId the id of the memberFunctionalityMember in the static model
 * @returns the accepted memberFunctionalityMember
*/
export const acceptChange = async(staticId) => {
    const response = await API.post(`/membersFunctionalitiesMembers/${staticId}/accept`);
    return response.data;
}

/**
 * Rejects a requested change for a machtiging
 * @param {*} staticId the id of the memberFunctionalityMember in the static model
 * @returns the rejected memberFunctionalityMember
*/
export const rejectChange = async(staticId) => {
    const response = await API.post(`/membersFunctionalitiesMembers/${staticId}/reject`);
    return response.data;
}